<script lang="ts" setup>
import type { FindOrderOut } from '~/types/ecommerce/generated.codegen';
defineProps<{
  order: FindOrderOut;
}>();
</script>

<template>
  <div class="order-integrator-card">
    <div class="header">
      <span class="title">Integrador</span>
    </div>
    <div class="info-content">
      <div class="info-base">
        <div class="line-item">
          <div class="info-item item-1 ">
            <span class="label">Nome Fantasia</span>
            <span class="value">{{ order.partner.trade_name }}</span>
          </div>
          <div class="info-item info-item-expand">
            <span class="label">Razão Social</span>
            <span class="value">{{ order.partner.corporate_name }}</span>
          </div>
          <div class="info-item item-3">
            <span class="label">CNPJ</span>
            <span class="value">{{ order.partner.document }}</span>
          </div>
        </div>

        <SolDivider
          orientation="horizontal"
          thickness="x-small"
        />

        <div class="line-item">
          <div class="info-item item-1 ">
            <span class="label">Inscrição Estadual</span>
            <span class="value">{{ order.partner.state_registration }}</span>
          </div>
          <div class="info-item info-item-expand">
            <span class="label">E-mail</span>
            <span class="value">{{ order.partner.email }}</span>
          </div>
          <div class="info-item item-3">
            <span class="label">Celular</span>
            <span class="value">{{ order.partner.phone }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scped lang="scss">
.order-integrator-card {
  @apply flex flex-col gap-4xs px-4xs py-2xs;
  @apply rounded-lg bg-neutral-high-light bg-opacity-intense;

  .header {
    @apply block;

    .title {
      @apply fonts-heading-h3;
    }
  }

  .info-content {
    @apply flex flex-col gap-4xs;

    .info-base {
      @apply flex flex-col gap-4xs;

      .line-item {
        @apply flex flex-col md:site:flex-row lg:site:flex-row items-between gap-4xs;

        .info-item {
          @apply flex flex-col;

          .label {
            @apply fonts-body-small-regular text-neutral-low-light;
          }

          .value {
            @apply fonts-body-medium-regular text-neutral-low-pure;
          }
        }
        .item-1 {
          @apply flex w-[226px] flex-col items-start;
        }
        .item-3 {
          @apply flex w-[160px] flex-col items-start;
        }
        .info-item-expand {
          @apply flex flex-col items-start;
          flex: 1 0 0;
        }
      }
    }
  }
}
</style>
